import classNames from 'classnames';
import type React from 'react';

interface Props {
  title: React.ReactNode;
  warning?: boolean;
  children?: React.ReactNode;
}

export default function ({ title, warning, children }: Props) {
  return (
    <div
      className={classNames({
        '-m-2 border-8 border-red-500 p-2 text-sm': !!warning,
      })}
    >
      <div className="sticky mb-4 mt-2 flex items-center justify-between text-base font-medium">{title}</div>

      {children}
    </div>
  );
}
